import axios from 'axios';

const API_URL = 'https://racceair.herokuapp.com'
const API_LOGIN = '/login'
const API_LOCAL= 'http://localhost:8080'

 const register = async (userData) => {
  const response = await axios.post("https://racceair.herokuapp.com/api/registerUser", userData)

  if (response.data) {
    localStorage.setItem('user', JSON.stringify(response.data))
  }

  return response.data
}


const createProject = async (projectData) => {
 const response = await axios.post('https://racceair.herokuapp.com/api/createProject', projectData)

 if (response.data) {
   localStorage.setItem('project', JSON.stringify(response.data))
 }

 return response.data
}


// Login user
const login = async (userData) => {
  console.log(userData)
  const response = await axios.post(API_URL+"/api/login", userData)

  if (response.data) {
    localStorage.setItem('user', JSON.stringify(response.data))
  }

  return response.data
}

// Logout user
const logout = () => {
  localStorage.removeItem('user')
}


const authService = {
  register,
  logout,
  login,
  createProject
}

export default authService
